import { render, staticRenderFns } from "./PasswordSetForm.vue?vue&type=template&id=1960c79d&"
import script from "./PasswordSetForm.vue?vue&type=script&lang=js&"
export * from "./PasswordSetForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)


    import installComponents from "!/Users/jurajpetras/dev/pmat/web/frontend/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BCol, BRow, BButton, BContainer} from 'bootstrap-vue'
    installComponents(component, {BCol, BRow, BButton, BContainer})
    

export default component.exports